import PropTypes from 'prop-types';
import React, { ReactNode } from 'react';
import getIn from '../connectedForm/utils/getIn';
import HeaderStatus, { StatusStyle } from '../connectedForm/HeaderStatus';
import { IPurchaseOrder } from '../../graphql/schema/p4types';
import HeaderTitle from '../connectedForm/HeaderTitle';

type IStatusFlag = {
  key: string;
  status: [
    {
      value: boolean;
      style: StatusStyle;
      title: string;
      titleKey?: string;
      tooltip?: string;
      icon?: string;
    }
  ];
};

type IPurchaseOrderHeaderProps = {
  optValue: string;
  orderNumber: string | number;
  statusFlags: IStatusFlag | Array<IStatusFlag>;
  values: any;
};

const PurchaseOrderHeader = ({ optValue, orderNumber, statusFlags, values }: IPurchaseOrderHeaderProps) => {
  const statusIndicators: ReactNode[] = [];
  if (statusFlags && Array.isArray(statusFlags)) {
    for (let i = 0; i < statusFlags.length; i++) {
      statusIndicators.push(...getStatusIndicator(statusFlags[i], values));
    }
  } else if (statusFlags) {
    statusIndicators.push(...getStatusIndicator(statusFlags, values));
  }

  return <HeaderTitle value={orderNumber} optValue={optValue} status={statusIndicators} />;
};

function getStatusIndicator(statusFlag: IStatusFlag, values: IPurchaseOrder) {
  if (!statusFlag.key || !statusFlag.status) return [];
  const value = getIn(values, statusFlag.key);
  if (!value) return [];
  const statusInd: ReactNode[] = [];

  for (let i = 0; i < statusFlag.status.length; i++) {
    const option = statusFlag.status[i];
    let title = option.title;
    if (option.titleKey) {
      const titleValue = getIn(values, option.titleKey);
      title = title ? `${title} ${titleValue}` : titleValue;
    }
    if (value === option.value) {
      statusInd.push(
        <HeaderStatus
          key={`${statusFlag.key}_${i}`}
          icon={option.icon}
          statusStyle={option.style}
          title={title}
          tooltip={option.tooltip}
        />
      );
    } else if (Array.isArray(value)) {
      const statuses: ReactNode[] = [];
      for (let j = 0; j < value.length; j++) {
        if (value[j] === option.value) {
          statuses.push(
            <HeaderStatus
              key={`${statusFlag.key}_${j}`}
              icon={option.icon}
              statusStyle={option.style}
              title={title}
              tooltip={option.tooltip}
            />
          );
        }
      }
      if (statuses.length > 0) statusInd.push(statuses);
    }
  }
  return statusInd;
}

PurchaseOrderHeader.propTypes = {
  optValue: PropTypes.string,
  title: PropTypes.string,
  value: PropTypes.string,
};

PurchaseOrderHeader.defaultProps = {
  optValue: null,
  title: '',
  value: '',
};

export default PurchaseOrderHeader;
